import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import dotenv from 'dotenv';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n.js';

import * as serviceWorker from './serviceWorker';
import { initGA } from './utils/ga';
import App from './App.js';
import './tailwind.css';

const tagManagerArgs = {
	gtmId: process.env.REACT_APP_GTM,
};

dotenv.config();

initGA();

if (module.hot) {
	module.hot.accept();
}

if (process.env.NODE_ENV === 'production') {
	TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(
	<I18nextProvider i18n={i18n}>
		<App />
	</I18nextProvider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
